<template>
  <div class="app-header">
    <div>
      <div class="page-title">
        {{ pageTitle }}
      </div>
      <div class="page-subtitle">
        {{ sectionTitle }} / {{ roleLabel }}
      </div>
    </div>
    <div class="header-actions">
      <el-tag type="info">
        {{ currentTerm }}
      </el-tag>
      <el-dropdown
        trigger="click"
        @command="handleCommand"
      >
        <div class="app-header__account">
          <el-avatar
            size="small"
            icon="el-icon-user-solid"
          />
          <span>{{ accountName }}</span>
          <i class="el-icon-arrow-down el-icon--right" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { clearAdminLoginSession } from "@/utils/admin-login";

export default {
  name: "AppHeader",
  computed: {
    pageTitle() {
      return this.$route.meta.title || "平台管理员后台";
    },
    sectionTitle() {
      return this.$route.meta.section || "平台";
    },
    roleMeta() {
      return this.$store.state.platform.roles[this.$store.state.platform.currentRole] || {};
    },
    roleLabel() {
      return this.roleMeta.label || "管理后台";
    },
    accountName() {
      return this.roleMeta.accountName || "管理员";
    },
    currentTerm() {
      return this.$store.state.platform.currentTerm;
    }
  },
  methods: {
    handleCommand(command) {
      if (command === "logout") {
        this.handleLogout();
      }
    },
    handleLogout() {
      clearAdminLoginSession(window.localStorage);
      this.$router.replace("/login");
      this.$message.success("已退出登录");
    }
  }
};
</script>

<style scoped>
.app-header__account {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #303133;
}

.app-header__account:focus,
.app-header__account:hover {
  color: #409eff;
}
</style>
